import { render, staticRenderFns } from "./AddCustomList.vue?vue&type=template&id=4636c16b"
import script from "./AddCustomList.vue?vue&type=script&lang=js"
export * from "./AddCustomList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports